export const ThemedImage = ({ day, night, alt, className = "", style, testId }) => (
  <picture className="contents">
    <source srcSet={night} media="(prefers-color-scheme: dark)" />
    <img src={day} alt={alt} className={className} style={style} data-testid={testId} />
  </picture>
);

// isotipo viewBox is 76x80
export const Logo = ({ size = 52, testId = "pensive-logo" }) => (
  <div className="flex items-center gap-2.5 select-none" data-testid={testId}>
    <ThemedImage day="/brand/isotipo.svg" night="/brand/isotipo-noche.svg" alt="" style={{ height: size, width: size * 0.95 }} />
    <span className="font-serif italic text-tinta" style={{ fontSize: size * 0.45, lineHeight: 1 }}>Pensive</span>
  </div>
);

// alt texts describe the posture, never an emotion
const POSTURE = {
  escucha: "Remanso escuchando, con la cabeza inclinada",
  espera: "Remanso sentado con los ojos cerrados, esperando en silencio",
  pregunta: "Remanso con una gota que cae sobre su cabeza",
  cuida: "Remanso sosteniendo una pequeña luz cálida frente a su pecho",
};
const EMOTION_POSTURE = {
  alegria: "Remanso que da un brinco con los brazos arriba",
  confianza: "Remanso de base ancha con los brazos abiertos",
  miedo: "Remanso pequeño que se abraza a sí mismo y tiembla",
  sorpresa: "Remanso que se estira hacia arriba con los brazos al aire",
  tristeza: "Remanso inclinado, con la cabeza baja y los brazos caídos",
  aversion: "Remanso que se hace para atrás y levanta la mano",
  ira: "Remanso compacto, con los puños cerrados y vapor sobre la cabeza",
  anticipacion: "Remanso de puntitas que mira hacia adelante con la mano sobre los ojos",
};

// estado: escucha (por defecto), espera (mientras escribe), pregunta (al responder), cuida (riesgo)
// height in px; never below 64
export const RemansoFigure = ({ estado = "escucha", height = 96, className = "", testId }) => {
  const h = Math.max(64, height);
  return (
    <ThemedImage
      day={`/brand/remanso-${estado}.svg`}
      night={`/brand/remanso-${estado}-noche.svg`}
      alt={POSTURE[estado]}
      className={className}
      style={{ height: h, width: h * (200 / 240) }}
      testId={testId}
    />
  );
};

// emotion Remansos have no night version: always on a paper circle
export const EmotionFigure = ({ id, height = 96, testId }) => (
  <span className="inline-flex items-center justify-center rounded-full shrink-0" style={{ background: "#F6F3EE", width: height + 20, height: height + 20 }} data-testid={testId}>
    <img src={`/brand/emocion-${id}.svg`} alt={EMOTION_POSTURE[id]} style={{ height, width: height * (200 / 240) }} />
  </span>
);
